import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { BedDouble, Plus } from 'lucide-react';
import useTrainingPlanStore from '../../stores/trainingPlanStore';
import WorkoutCard from './WorkoutCard';

export default function DayCell({ weekId, slotIndex, isHidden }) {
  const language = localStorage.getItem('language') || 'english';
  const he = language === 'hebrew';
  const week = useTrainingPlanStore((state) => state.weeks[weekId]);
  const slot = week?.slots[slotIndex];
  const createWorkoutForSlot = useTrainingPlanStore((state) => state.createWorkoutForSlot);

  const droppableId = `${weekId}_${slotIndex}`;
  const { isOver, setNodeRef } = useDroppable({
    id: droppableId,
    data: { type: 'day_cell', weekId, slotIndex },
  });

  if (isHidden || !slot) return null;

  const isWorkout = slot.kind === 'workout' && slot.workout_id;
  const isRest = slot.kind === 'rest' || (!isWorkout && slot.kind !== 'empty');

  return (
    <div
      ref={setNodeRef}
      className={`relative min-h-[56px] lg:min-h-[168px] h-full rounded-lg border transition-[transform,opacity] duration-120 ${
        isOver
          ? 'border-forest bg-forest-faint dark:bg-forest-faint-dark'
          : 'border-transparent bg-surface/50 dark:bg-surface-dark'
      }`}
    >
      {isWorkout ? (
        <WorkoutCard workoutId={slot.workout_id} weekId={weekId} slotIndex={slotIndex} />
      ) : (
        <div
          className={`h-full flex flex-row lg:flex-col justify-between lg:justify-center items-center gap-3 rounded-md border px-3 py-2 lg:p-2 ${
            isRest
              ? 'border-line dark:border-line-dark bg-moss/60 dark:bg-moss-dark/40 text-ink-muted'
              : 'border-line dark:border-line-dark bg-surface dark:bg-surface-dark text-ink-muted'
          }`}
        >
          <div className="flex min-w-0 flex-row lg:flex-col items-center gap-2 lg:gap-1.5">
            <BedDouble size={20} className="shrink-0 lg:h-6 lg:w-6" aria-hidden="true" />
            <span className="text-[11px] font-semibold tracking-wider uppercase text-ink dark:text-ink-dark">
              {he ? 'יום מנוחה' : 'Rest day'}
            </span>
            {slot.notes ? (
              <p className="truncate lg:whitespace-normal text-[11px] text-ink-muted lg:text-center leading-snug lg:max-w-[9rem]">{slot.notes}</p>
            ) : null}
          </div>

          <button
            type="button"
            onClick={() => createWorkoutForSlot(weekId, slotIndex, language)}
            aria-label={he ? 'הוסף אימון' : 'Add workout'}
            className="shrink-0 min-h-10 lg:min-h-11 px-3 rounded-md border border-line dark:border-line-dark bg-surface dark:bg-surface-dark text-[11px] font-semibold text-ink dark:text-ink-dark hover:bg-canvas dark:hover:bg-canvas-dark active:scale-[0.98] transition-colors duration-120 outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2 inline-flex items-center gap-1.5"
          >
            <Plus size={14} strokeWidth={2.5} aria-hidden="true" />
            {he ? 'הוסף אימון' : 'Add workout'}
          </button>
        </div>
      )}
    </div>
  );
}
